import { render, staticRenderFns } from "./GBoothStoryForm.vue?vue&type=template&id=681b5dcf&scoped=true&"
import script from "./GBoothStoryForm.vue?vue&type=script&lang=ts&"
export * from "./GBoothStoryForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothStoryForm.vue?vue&type=style&index=0&id=681b5dcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b5dcf",
  null
  
)

export default component.exports